import { mapGetters, mapState } from 'vuex'

const noAccess = user => !user || !user.accessLevel || !user.access

const superAdminAccessLevel = 15 // 11 for testing. 10 for reals.

export default {
  computed: {
    ...mapGetters(['sortedRegions']),
    ...mapState(['user', 'teams']),
    isSuperAdmin () {
      return this.user && this.user.accessLevel >= superAdminAccessLevel
    },
    canSeeAdjustedTotals () {
      return this.isSuperAdmin
    },
    accessibleTeams () {
      if (this.isSuperAdmin) {
        return this.teams.slice(0)
      } else if (noAccess(this.user)) {
        return []
      }
      return this.teams.filter(t =>
        this.user.access.teams.includes(t.id) ||
        this.user.access.regions.includes(t.regionId)
      )
    },
    accessibleRegions () {
      if (this.isSuperAdmin) {
        return this.sortedRegions.slice(0)
      } else if (noAccess(this.user)) {
        return []
      }
      return this.sortedRegions.filter(r =>
        this.user.access.regions.includes(r.id) ||
        this.accessibleTeams.map(t => t.regionId).includes(r.id)
      )
    }
  }
}
